/**
 * Demo model shown on the landing hero and the How it works page.
 * Hosted in GCS (keeps big samples out of the deploy; Cloudflare Pages caps files at 25 MiB).
 * Generated by scripts/landing-model/generate_sawtooth_hall.py — bump the -vN suffix on change (immutable cache).
 */
export const SAMPLE_MODEL = {
  url: 'https://storage.googleapis.com/bimdrop-c35bd.firebasestorage.app/samples/sawtooth-timber-hall-v1.ifc',
  fileName: 'sawtooth-timber-hall-v1.ifc',
}
